// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */@media (min-width:1024px){.header.full-size section.header-section.section:before,.header.headroom--not-top section.header-section.section:before{background-color:var(--header-pinned-border)}}@media (max-width:1023px){.header.full-size section.header-section.section{box-shadow:var(--header-full-size-shadow)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
